<template>
  <v-row>
    <v-col class="d-flex flex-wrap justify-space-between">
      <v-btn v-if="previous" class="prev" @click="go('previous')"><i class="fal fa-chevron-left"></i></v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" class="next" v-if="next" :disabled="!valid" @click="go('next')">Next</v-btn>
      <v-btn color="primary" class="next" v-if="submit" :disabled="!valid" @click="submit">Submit</v-btn>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">
  .v-btn {
    font-size: 18px;
    padding: 10px 25px !important;
    height: auto !important;
    width: 100%;
    margin-bottom: 20px;

    @media screen and (min-width: 600px) {
      width: auto;
    }
  }
</style>

<script>
import Scroll from 'vue-scrollto'

export default {
  props: {
    previous: Boolean,
    next: Boolean,
    valid: Boolean,
    submit: Function
  },
  methods: {
    go: function(direction) {
      setTimeout(() => {
        Scroll.scrollTo('#starting', 0, {})
      }, 100);
      this.$store.commit(direction)
    },
  }
}
</script>
